import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MyCount from "../../../components/MyPage/MyCount";
import { DELIVERY_LIST_URL, DELIVERY_DELETE_URL } from "../../../utils/urls";
import instance from "../../../services/services";
import { formatPhoneNumber } from "../../../utils/validation";
import PopupLoginError from "../../../components/Popup/LoginError";
import { useLanguage } from "../../../hooks/useLanguage";


function DeliveryAddrList(){
  const { t } = useLanguage();
  const [isTablet, setIsTablet] = useState(false);
  const [deliveryAddrList, setDeliveryAddrList] = useState([]);
  const [selectedAddresses, setSelectedAddresses] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const navigate = useNavigate();

  // 모바일 체크
  useEffect(() => {
    const checkTablet = () => {
      setIsTablet(window.innerWidth < 768);
    };
    
    checkTablet();
    window.addEventListener('resize', checkTablet);
    
    return () => window.removeEventListener('resize', checkTablet);
  }, []);
  
  const handleDeliveryAddrRegister = () => {
    navigate('/myPage/delivery/register')
  }

  useEffect(() => {
    fetchDeliveryAddrList();
  }, []);

  // 배송지 목록 가져오기
  const fetchDeliveryAddrList = async () => {
    try {
      const response = await instance.post(DELIVERY_LIST_URL);
      setDeliveryAddrList(response.data.data);
      
      // 기본 배송지 자동 체크
      const defaultAddresses = response.data.data
        .filter(item => item.default_flag === 'Y')
        .map(item => item.mde_seq);
        
      setSelectedAddresses(defaultAddresses);
    } catch (error) {
      console.log(error, ':::error');
    }
  }
  
  // 체크박스 변경 핸들러
  const handleCheckboxChange = (mde_seq) => {
    setSelectedAddresses(prev => {
      if (prev.includes(mde_seq)) {
        return prev.filter(seq => seq !== mde_seq);
      } else {
        return [...prev, mde_seq];
      }
    });
  }
  
  // 선택 주소 삭제
  const handleDeleteSelected = async () => {
    if (selectedAddresses.length === 0) {
      setIsPopupOpen(t('delete_item'));
      return;
    }
    
    try {
      // 선택된 주소 하나씩 삭제
      for (const mde_seq of selectedAddresses) {
        await instance.post(DELIVERY_DELETE_URL, {
          mde_seq: mde_seq
        });
      }
      
      // 삭제 후 목록 다시 불러오기
      fetchDeliveryAddrList();
      
      // 선택 배열 초기화
      setSelectedAddresses([]);
      
      setIsPopupOpen(t('address_deleted'));
    } catch (error) {
      console.error('주소 삭제 실패:', error);
      setIsPopupOpen('주소 삭제 중 오류가 발생했습니다.');
    }
  }
  
  return(
    <div>
      <div>
        {/* 장바구니 / 관심상품 / 쿠폰 */}
        {!isTablet && <MyCount/>}

        <div className="my_container point_container mt_48">
          <div className="order_title">
            <h3>{t('address_management')}</h3>
          </div>

          {/* 데이터 없을때 */}
          {deliveryAddrList.length === 0 && (
            <div className="default_info_table no_data text_center pt_48">
              {t('no_address')}
            </div>
          )}

          <ul className="default_info_list address_list">
            {/* 기본 뱃지 있는 주소 */}
            {deliveryAddrList.map((item, index) => (
              <li className="info_item" key={index}>
                <div className="info_detail default_chk_box mx-0 top">
                  <input
                    id={`address_${item.mde_seq}`}
                    type="checkbox"
                    checked={selectedAddresses.includes(item.mde_seq)}
                    onChange={() => handleCheckboxChange(item.mde_seq)}
                  />
                  <label htmlFor={`address_${item.mde_seq}`}></label>
                </div>
                <div className="delivery_info">
                  <div className="info_detail flex1">
                    <div className="delivery_detail">
                      <div className="title">
                        {item.default_flag === 'Y' && (
                        <span className="badge g-100 sm">{t('default')}</span>
                        )}
                        <span className="addr_name">{item.mde_title}</span>
                        <span className="addr_name">({item.recipient_name})</span>
                      </div>
                      <div className="info">
                        <p>
                          [{item.recipient_zipcode}]
                          {item.recipient_address_street}
                          ({item.recipient_address_detail})
                        </p>
                        <p>{formatPhoneNumber(item.recipient_phone)}</p>
                      </div>
                    </div>
                  </div>
                  <div className="info_detail addr_edit_btn">
                    <button
                      type="button"
                      className="default_btn xs white"
                      onClick={() => navigate(`/myPage/delivery/register?mde_seq=${item.mde_seq}`, {
                        state: {
                          deliveryInfo: {
                            mde_title: item.mde_title,
                            recipient_name: item.recipient_name,
                            recipient_phone: item.recipient_phone,
                            default_flag: item.default_flag
                          },
                          deliveryAddress: {
                            zonecode: item.recipient_zipcode,
                            roadAddress: item.recipient_address_street,
                            detailAddress: item.recipient_address_detail
                          }
                        }
                      })}
                    >
                      {t('modify')}
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          <div className="btm_btn_box">
            <button 
              type="button"
              className="default_btn white"
              onClick={handleDeleteSelected}
            >
              {t('select_address_delete2')}
            </button>
            <button 
              type="button"
              className="default_btn black" 
              onClick={handleDeliveryAddrRegister}
            >
              {t('delivery_address_registration')}
            </button>
          </div>
        </div>
      </div>
      <PopupLoginError isPopup={isPopupOpen} setIsPopup={setIsPopupOpen}/>
    </div>
  )
};
export default DeliveryAddrList;